import React from "react";
import { observer, inject } from "mobx-react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
// import Alert from '@material-ui/lab/Alert';

// import GridOnIcon from '@material-ui/icons/GridOn';
import {
  Popover as MUIPopover,
  Typography,
  Button,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import Reminder from "./components/Reminder";
import StyledToolbarButton, {
  StyledToolbarTitle,
} from "../ToolBar/StyledToolbarButton";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import AddAlarmIcon from "@material-ui/icons/AddAlarm";

class RemindersPopup extends React.Component {
  constructor(props) {
    super(props);

    this.baseGrid = Ext.create("TL.list.BaseGrid");
  }
  componentDidMount() {
    this.props.store.fetchData();
  }

  // componentDidUpdate() {
  //     this.props.store.isExtjsDelayedRender = false;
  // }

  render() {
    let store = this.props.store,
      { isAddNewReminderShown, isReminderSavedTextShown, dateColumns } = store,
      Cmp;
    const type = store.isScheduled ? "Reminder" : "Notification";
    const Icon = store.isScheduled ? AddAlarmIcon : AddAlertIcon;

    if (store.isLoading) {
      Cmp = <CircularProgress size={20} />;
    } else {
      Cmp = (
        <Grid
        // container
        // spacing={2}
        // justify="flex-start"
        // alignItems="center"
        >
          <Grid item>
            <Typography variant="body" style={{ fontSize: 13, color: "#444" }}>
              {store.isScheduled
                ? "Reminders allow you to recieve notification emails before or after\n a specific date in the record"
                : "Send an email notification when..."}
            </Typography>
          </Grid>

          {store.isScheduled && dateColumns.length === 0 && (
            <Grid item xs={12} style={{ paddingTop: 20 }}>
              <div
                style={{
                  color: "#444",
                  backgroundColor: "#f5f5f5",
                  padding: 20,
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ErrorOutlineIcon
                  style={{
                    color: "#444",
                  }}
                />
                We did not find a date field in the sheet. Try adding a date
                field, say 'Due date', 'Renewal date',
                <br />
                'Contract expires', etc.
              </div>
            </Grid>
          )}
          <div style={{ paddingTop: 20, paddingBottom: 10 }}>
            {(!store.isScheduled || dateColumns.length !== 0) &&
              store.reminders.map((reminder, key) => {
                return (
                  <Reminder
                    key={key}
                    reminderKey={key}
                    reminder={reminder}
                    store={store}
                  />
                );
              })}
          </div>
          {isReminderSavedTextShown && (
            <div style={{ color: "green" }}>{type} saved successfully.</div>
          )}
          {isAddNewReminderShown && !isReminderSavedTextShown && (
            <Button
              // variant="contained"
              color="primary"
              component="a"
              onClick={store.addNewReminder}
            >
              + Add one more {type}
            </Button>
          )}
        </Grid>
      );
    }

    return (
      <>
        <StyledToolbarButton
          aria-haspopup="true"
          highlighted={store.hasReminders}
          onClick={store.handleClick}
          className="d-flex"
        >
          <Icon size={18} style={{ width: 18, height: 18 }} />
          <StyledToolbarTitle>{type}s</StyledToolbarTitle>
        </StyledToolbarButton>
        <MUIPopover
          open={Boolean(store.anchorEl)}
          anchorEl={store.anchorEl}
          onClose={store.handleClose}
          disableEnforceFocus // issue fix with extjs input boxes focus.
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          PaperProps={{
            className: "view_aggregation_popup",
            style: {
              minWidth: store.isScheduled ? 700 : 500,
            },
          }}
        >
          {Cmp}
        </MUIPopover>
      </>
    );
  }
}

export default observer(RemindersPopup);
